var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_vm._v(_vm._s(_vm.index + 1))]), _c('td', {
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_vm.canReadProduct && !_vm.readonly ? _c('v-autocomplete', {
    key: 'product' + _vm.index + _vm.value.productId,
    attrs: {
      "placeholder": _vm.$t('objects.invoiceLine.title') + ' *',
      "hide-details": "auto",
      "dense": "",
      "value": _vm.value.product,
      "readonly": _vm.readonly,
      "items": _vm.products,
      "return-object": "",
      "item-text": "title",
      "item-value": "id",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
      "search-input": _vm.value.search
    },
    on: {
      "input": _vm.onProductInput,
      "update:search-input": function updateSearchInput($e) {
        return _vm.debouncedProductSearch($e, _vm.value);
      },
      "focus": function focus($event) {
        return _vm.searchProduct('', _vm.value);
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function fn() {
        return [_vm.value.isLoading ? _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("tag.selectTags.searching")) + " ")])], 1)], 1) : _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("repairEstimate.LineItemsForm.noResults", {
          search: _vm.value.search
        })) + " ")])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s(item.title))])];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.title) + " "), item.coverageType ? _c('v-chip', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v(_vm._s(_vm.$t("enums.CoverageTypeEnum.".concat(item.coverageType))) + " ")]) : _vm._e(), item.externalId ? _c('v-chip', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v(" " + _vm._s(item.externalId) + " ")]) : _vm._e(), item.code ? _c('v-chip', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v(" " + _vm._s(item.code) + " ")]) : _vm._e()], 1), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(item.description) + " ")])], 1)];
      }
    }], null, false, 913576293)
  }) : _c('v-text-field', {
    attrs: {
      "placeholder": _vm.$t('objects.invoiceLine.title'),
      "dense": "",
      "hide-details": "auto",
      "readonly": _vm.readonly,
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.title,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "title", $$v);
      },
      expression: "value.title"
    }
  })], 1), _c('td', {
    staticClass: "text-end",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('v-text-field', {
    staticClass: "text-right",
    attrs: {
      "placeholder": _vm.$t('objects.invoiceLine.amount'),
      "dense": "",
      "hide-details": "auto",
      "type": "number",
      "readonly": _vm.readonly,
      "min": 1,
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
      "suffix": _vm.currencySymbolMap.get(_vm.currency)
    },
    model: {
      value: _vm.value.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "amount", _vm._n($$v));
      },
      expression: "value.amount"
    }
  })], 1), _c('td', {
    staticClass: "text-end",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('v-text-field', {
    staticClass: "text-right",
    attrs: {
      "placeholder": _vm.$t('objects.invoiceLine.quantity'),
      "dense": "",
      "hide-details": "auto",
      "type": "number",
      "readonly": _vm.readonly,
      "min": 1,
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE, _vm.RulesEnum.NOT_NEGATIVE_RULE, _vm.RulesEnum.GREATER_ZERO_RULE)
    },
    model: {
      value: _vm.value.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "quantity", _vm._n($$v));
      },
      expression: "value.quantity"
    }
  })], 1), _c('td', {
    staticClass: "text-end",
    staticStyle: {
      "width": "60px",
      "border-bottom": "none"
    }
  }, [_vm.taxRates ? _c('v-autocomplete', {
    staticClass: "text-right",
    attrs: {
      "placeholder": _vm.$t('objects.invoiceLine.taxRate'),
      "hide-details": "auto",
      "dense": "",
      "type": "number",
      "min": 0,
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE, _vm.RulesEnum.NOT_NEGATIVE_RULE),
      "readonly": _vm.readonly,
      "items": _vm.taxRates
    },
    model: {
      value: _vm.value.taxRate,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "taxRate", _vm._n($$v));
      },
      expression: "value.taxRate"
    }
  }) : _c('v-text-field', {
    staticClass: "text-right",
    attrs: {
      "placeholder": _vm.$t('objects.invoiceLine.taxRate'),
      "dense": "",
      "hide-details": "auto",
      "step": 1,
      "min": 0,
      "max": 100,
      "type": "number",
      "readonly": _vm.readonly,
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE, _vm.RulesEnum.NOT_NEGATIVE_RULE, _vm.RulesEnum.MAX_RULE_100)
    },
    model: {
      value: _vm.value.taxRate,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "taxRate", _vm._n($$v));
      },
      expression: "value.taxRate"
    }
  })], 1), _c('td', {
    staticClass: "text-end",
    staticStyle: {
      "width": "120px",
      "border-bottom": "none"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.amount * _vm.value.quantity, _vm.currency)) + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }